import companyInfoJson from "/public/companyInfo.json";
export default {
    name:companyInfoJson.name,
    logo:companyInfoJson.logo
}